export default __webpack_public_path__ + "static/media/MuseoSans_700-webfont.89df198e.ttf";